import React from 'react';
import PropTypes from 'prop-types';
import { ButtonToolbar, Button } from 'react-bootstrap';
import { Translate } from 'react-redux-i18n';

import GenericSelection from '../../../Common/GenericSelection';
import { ROOT_URL, ROOT_API_URL } from "../../../../actions/root_url";

const isHMM = ROOT_API_URL === 'https://hmm-scm.truckxi.com/api/';

const propTypes = {
  paymentTypeSelected: PropTypes.string,
  methodSelected: PropTypes.string,
  quantityFrom: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  quantityTo: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  discountValue: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  discountType: PropTypes.string,
  applyLv1: PropTypes.bool,
  applyLv2: PropTypes.bool,
  applyLv3: PropTypes.bool,
  applyLv4: PropTypes.bool,
  applyLv5: PropTypes.bool,
  handlePriceLevelChange: PropTypes.func,
  handleSelectionChange: PropTypes.func,
  handleTextInputChange: PropTypes.func,
  handleDiscountButtonClick: PropTypes.func,
};

const defaultProps = {
  paymentTypeSelected: '',
  methodSelected: '',
  quantityFrom: '',
  quantityTo: '',
  discountValue: '',
  discountType: '',
  applyLv1: true,
  applyLv2: true,
  applyLv3: true,
  applyLv4: true,
  applyLv5: true,
  handlePriceLevelChange: () => {},
  handleSelectionChange: () => {},
  handleTextInputChange: () => {},
  handleDiscountButtonClick: () => {},
};


const ByQuantityFields = ({
  paymentTypeSelected,
  methodSelected,
  quantityFrom,
  quantityTo,
  discountValue,
  discountType,
  applyLv1,
  applyLv2,
  applyLv3,
  applyLv4,
  applyLv5,
  handlePriceLevelChange,
  handleSelectionChange,
  handleTextInputChange,
  handleDiscountButtonClick,
}) => {
  const methodOptions = [
    { label: 'Every', value: 'Every' },
    { label: 'Each', value: 'Each' },
  ];
  return (
    <div className="promo-fields">
      {
        isHMM &&
        <div className="levels-field">
          <label style={{ marginRight: '10px' }} htmlFor="levels" className="field-margin "><Translate value="levels" />:</label>
          <ButtonToolbar>
            <Button
              bsStyle={(applyLv1 === true) ? 'success' : 'null'}
              className="level-buttons"
              onClick={() => handlePriceLevelChange('applyLv1')}
            >
              1
          </Button>
            <Button
              bsStyle={(applyLv2 === true) ? 'success' : 'null'}
              className="level-buttons"
              onClick={() => handlePriceLevelChange('applyLv2')}
            >
              2
          </Button>
            <Button
              bsStyle={(applyLv3 === true) ? 'success' : 'null'}
              className="level-buttons"
              onClick={() => handlePriceLevelChange('applyLv3')}
            >
              3
          </Button>
            <Button
              bsStyle={(applyLv4 === true) ? 'success' : 'null'}
              className="level-buttons"
              onClick={() => handlePriceLevelChange('applyLv4')}
            >
              4
          </Button>
            <Button
              bsStyle={(applyLv5 === true) ? 'success' : 'null'}
              className="level-buttons"
              onClick={() => handlePriceLevelChange('applyLv5')}
            >
              5
          </Button>
          </ButtonToolbar>
        </div>
      }
      <div className="method-selection">
        <GenericSelection
          translation={<Translate value="method" />}
          setSelected={({ value }) => handleSelectionChange(value, 'methodSelected')}
          value={methodSelected}
          options={methodOptions}
          colon
        />
      </div>
      <div className="quantity-field">
        <label htmlFor="quantity" className="field-margin"><Translate value="qty" />:</label>
        <div className="quantity-input">
          <input
            id="quantity-to-from"
            name="quantityFrom"
            className="text-input-field"
            type="text"
            value={quantityFrom}
            onChange={handleTextInputChange}
            // disabled={paymentTypeSelected === 'Mobile'}
          />
          <label htmlFor="to" className="to-label field-margin"><Translate value="to" /></label>
          <input
            id="quantity-to-from"
            name="quantityTo"
            className="text-input-field"
            type="text"
            value={quantityTo}
            onChange={handleTextInputChange}
            // disabled={paymentTypeSelected === 'Mobile'}
          />
        </div>
      </div>
      <div className="discount-field">
        <label htmlFor="discount" className="field-margin "><Translate value="discount" />:</label>
        <input
          id="discount-text-input"
          name="discountValue"
          className="text-input-field"
          type="text"
          value={discountValue}
          onChange={handleTextInputChange}
        />
        <ButtonToolbar>
          <Button
            bsStyle={(discountType === 'Dollar') ? 'success' : 'null'}
            onClick={() => handleDiscountButtonClick('Dollar')}
          >
            <em className="fa fa-usd" />
          </Button>
          <Button
            bsStyle={(discountType === 'Percent') ? 'success' : 'null'}
            onClick={() => handleDiscountButtonClick('Percent')}
          >
            <em className="fa fa-percent" />
          </Button>
        </ButtonToolbar>
      </div>
    </div>
  );
};

ByQuantityFields.propTypes = propTypes;
ByQuantityFields.defaultProps = defaultProps;

export default ByQuantityFields;



// WEBPACK FOOTER //
// ./master/jsx/components/Sales/PromotionsPage/components/ByQuantityFields.jsx